import { Grid, TextField } from "@material-ui/core";
import { IImportationParameters } from "api/interfaces";
import useValidations from "hooks/useValidations";
import { lang } from "i18nLang";
import { useEffect } from "react";
import AutoCompleteField from "../../UI/Fields/AutoCompleteField";
import { ColumnControl, RedText, Title } from "./styles";

interface ITabParametersProps {
  values: IImportationParameters;
  fileTabs: { name: string; id: number }[];
  loadingFileTab: boolean;
  onChange: (name: string, value: number) => void;
  onChangeErrors: (hasError: boolean) => void;
}

const TabParameters = ({
  values,
  fileTabs,
  loadingFileTab,
  onChange,
  onChangeErrors,
}: ITabParametersProps) => {
  const { validated, validateFields } = useValidations({
    tabIndex: "required",
    startRow: {
      required: true,
      greaterThan: { valueToCompare: 0 },
    },
    finalRow: { greaterThan: { valueToCompare: 0 } },
  });

  useEffect(() => {
    const hasErrors = !validateFields(values, true);
    onChangeErrors(hasErrors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeAutoComplete = (name, value) => {
    onChange(name, value?.id);
  };

  const handleChangeInput = (ev) => {
    let { name, value } = ev.target;
    value = value ? Number(value) : undefined;
    onChange(name, value);
  };

  const handleBlurInput = (ev) => {
    const { name, value } = ev.target;
    const hasError = !validateFields({ [name]: value });
    onChangeErrors(hasError);
  };

  const handleKeyUpStartRow = (ev) => {
    if (ev.key === "Tab") {
      const inputId = ev.shiftKey ? "inpTabIndex" : "inpFinalRow";
      const input = document.getElementById(inputId);
      if (input) input.focus();
    }
  };

  const handleKeyUpFinalRow = (ev) => {
    if (ev.key === "Tab") {
      const inputId = ev.shiftKey ? "inpStartRow" : "btnCancelModal";
      const input = document.getElementById(inputId);
      if (input) input.focus();
    }
  };

  return (
    <>
      <Title>{lang(`importation.modeFile.subtitle2`)}</Title>
      <ColumnControl container justifyContent="center">
        <Grid container item xs={6} md={5} alignItems="center">
          {lang(`importation.modeFile.tab`)}
          <RedText>*</RedText>
        </Grid>
        <Grid container item xs={6} md={5} alignItems="center">
          <AutoCompleteField
            id="inpTabIndex"
            name="tabIndex"
            label={lang(`importation.modeFile.tab`)}
            options={fileTabs}
            fullWidth
            value={fileTabs.find((t) => t.id === values.tabIndex)}
            onChangeOption={handleChangeAutoComplete}
            loading={loadingFileTab}
            onBlur={handleBlurInput}
            InputProps={{
              error: !validated.tabIndex.valid,
              helperText: validated.tabIndex.text,
            }}
          />
        </Grid>
      </ColumnControl>
      <ColumnControl container justifyContent="center">
        <Grid container item xs={6} md={5} alignItems="center">
          {lang(`importation.modeFile.startRow`)}
          <RedText>*</RedText>
        </Grid>
        <Grid container item xs={6} md={5} alignItems="center">
          <TextField
            id="inpStartRow"
            name="startRow"
            label={lang(`importation.modeFile.line`)}
            type="number"
            fullWidth
            value={values.startRow}
            onChange={handleChangeInput}
            onBlur={handleBlurInput}
            onKeyUp={handleKeyUpStartRow}
            helperText={validated.startRow.text}
            error={!validated.startRow.valid}
          ></TextField>
        </Grid>
      </ColumnControl>
      <ColumnControl container justifyContent="center">
        <Grid container item xs={6} md={5} alignItems="center">
          {lang(`importation.modeFile.finalRow`)}
        </Grid>
        <Grid container item xs={6} md={5} alignItems="center">
          <TextField
            id="inpFinalRow"
            name="finalRow"
            label={lang(`importation.modeFile.line`)}
            type="number"
            fullWidth
            value={values.finalRow}
            onChange={handleChangeInput}
            onBlur={handleBlurInput}
            onKeyUp={handleKeyUpFinalRow}
            helperText={validated.finalRow.text}
            error={!validated.finalRow.valid}
          ></TextField>
        </Grid>
      </ColumnControl>
    </>
  );
};

export default TabParameters;
